import '../index.css';
var styles = {
  "ghost": "bp_ghost_module_ghost--fe745",
  "ghost-keyframes": "bp_ghost_module_ghost-keyframes--fe745",
  "circle": "bp_ghost_module_circle--fe745",
  "pill": "bp_ghost_module_pill--fe745",
  "rectangle": "bp_ghost_module_rectangle--fe745"
};
export { styles as default };